import vars from './vars';
import router from './router';

vars.$hashCarousel.slick({
	infinite: true,
	centerMode: true,
	variableWidth: true,
});

vars.$hashCarousel.on('afterChange', (event, slick, currentSlide) => {
	let $this = $(`[data-slick-index="${currentSlide}"] .home__hash-carousel__item`);
	let href = $this.attr('href');
	let name = $this.text();

	vars.$hashRead.data('href', href);
	vars.$hashRead.attr('data-href', href);
	vars.$hashRead.data('name', name);
	vars.$hashRead.attr('data-name', name);
});

vars.$hashRead.on('click', (e) => {
	let url = $(e.currentTarget).data('href');
	let name = $(e.currentTarget).data('name');

	if (url.match('/article/')) {
		router.navigate(url);
		vars.$document.trigger('tag-click', name);
	} else {
		window.open(url, '_blank');
		vars.$document.trigger('tag-click-dex');
	}
});
